import { useEffect, useState, useRef } from 'react'

/* global grecaptcha */

/**
 * reCAPTCHA verification API
 * This function verifies a reCAPTCHA token with Google's API
 */

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY

/**
 * Custom hook for reCAPTCHA initialization
 * @returns {object} Object containing recaptchaReady state
 */
export const useRecaptcha = () => {
  const [recaptchaReady, setRecaptchaReady] = useState(false)
  const initStartedRef = useRef(false)

  useEffect(() => {
    const checkRecaptchaReady = () => {
      if (!initStartedRef.current && typeof grecaptcha !== 'undefined' && typeof grecaptcha.ready !== 'undefined') {
        initStartedRef.current = true
        grecaptcha.ready(() => {
          console.log('reCAPTCHA is fully initialized')
          // Render reCAPTCHA into a hidden container to create the client
          try {
            grecaptcha.render('recaptcha-container', {
              'sitekey': RECAPTCHA_SITE_KEY,
              'size': 'invisible'
            })
            console.log('reCAPTCHA rendered successfully')
            setRecaptchaReady(true)
          } catch (error) {
            console.error('Failed to render reCAPTCHA:', error)
            setRecaptchaReady(false)
            initStartedRef.current = false // Reset if failed
          }
        })
      } else if (!initStartedRef.current) {
        // If not ready yet, check again in 100ms
        setTimeout(checkRecaptchaReady, 100)
      }
    }
    
    // Start checking for reCAPTCHA readiness
    checkRecaptchaReady()
  }, [])

  return { recaptchaReady }
}

/**
 * Execute reCAPTCHA and get token
 * @returns {Promise<string>} The reCAPTCHA token
 */
export const getRecaptchaToken = async () => {
  console.log('Getting reCAPTCHA token...')
  
  // Execute reCAPTCHA to get token
  const recaptchaToken = await grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'vincentric_api' })
  console.log('reCAPTCHA token obtained successfully')
  
  return recaptchaToken
}
